// This roles should have same definititon/values as in backend

const ROLES = {
  'user': 1,
  'provider': 2,
  'galt': 3
}

export default ROLES;
